<template>
  <div :class="[{'padtop': stickyHeader}]" :style="{'padding': bodypadding}">
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    bodypadding: {
      type: String,
      default: ''
    },
  },
  computed: {
    stickyHeader() {
      return this.$parent.stickyHeader;
    }
  }

}
</script>
